import { Injectable } from '@angular/core';
//import { HttpClientService } from './httpClient.service';
//import { constants } from '../utitlity/constant';
import { HttpClientService } from './httpClient.service';
import { constants } from '../utitlity/constant';
import { Helper } from '../utitlity/helper';
import { DocumentInfo, DocObj } from '../models/doc-upload.model';

@Injectable()
export class DocUploadService {

    constructor(private http: HttpClientService) {

    }
    dataURItoBlob(dataURI) {

        var blob;
        var arr = dataURI.split(','), mimeString = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        blob = new Blob([u8arr], { type: mimeString });

        return blob;
    }
    getFileType(type) {
        if (type) {
            return type.split('/')[1];
        }
        return '';
    }
    clearDocUploadMsg(documentSelected: DocumentInfo) {
        setTimeout(() => {
            documentSelected.docUploadMsg = '';
        }, 5000)
    }

    getDocUploadApiMessage(msg, msgType) {
        return '<span class="text-' + msgType + '"><strong>' + msg + '</strong></span>';

    }

    renderFile(file, documentSelected: DocumentInfo, isCameraImage?: boolean) {
        if (!isCameraImage) {
            let reader = new FileReader();
            reader.onload = (loadEvent: any) => {
                let errMsg = this.checkForDocUploadErr(file, documentSelected);
                if (errMsg) {
                    documentSelected.docUploadMsg = errMsg
                    this.clearDocUploadMsg(documentSelected);
                    return;
                }
                let imageSrc, pdfSrc;
                if (file.name.split('.')[file.name.split('.').length - 1].toLowerCase() === 'pdf') {
                    imageSrc = '/content/dam/hsbc/ae/uaeapplication/images/pdf_icon.jpg';
                   // imageSrc = 'images/pdf_icon.jpg';
                    pdfSrc = loadEvent.target.result;

                } else {
                    imageSrc = loadEvent.target.result;
                }

                if (documentSelected) {

                    let docIndex: any = {};
                    docIndex.image = imageSrc;
                    docIndex.file = file;
                    docIndex.fileName = file.name;
                    docIndex.pdfSrc = pdfSrc;
                    docIndex.fileType = this.getFileType(file.type);
                    documentSelected.files.push(docIndex);

                }


            }
            reader.readAsDataURL(file);
        } else {
            let errMsg = this.checkForDocUploadErr(file, 'camera');
            if (errMsg) {
                documentSelected.docUploadMsg = errMsg;
                this.clearDocUploadMsg(documentSelected);
                return;
            }
            let blob = this.dataURItoBlob(file);
            let docIndex: any = {};

            docIndex.image = file;
            docIndex.isCameraImage = isCameraImage;
            docIndex.file = blob;
            docIndex.fileName = 'image' + documentSelected.index + '.jpeg';
            docIndex.fileType = 'jpeg';
            documentSelected.files.push(docIndex);

        }
    }

    checkForDocUploadErr(file, camera?) {
        let fileFormat = ['jpeg', 'png', 'pdf', 'jpg'];
        const fileType = camera ? 'jpeg' : this.getFileType(file.type);
        let msg = '';
        if (file.size / (1024 * 1024) >= 3) {
            msg = Helper.createDocUploadMsg('Please uplaod the document(s) less than 3MB.', 'danger')
        } else if (fileFormat.indexOf(fileType) == -1) {
            msg = Helper.createDocUploadMsg('Please uplaod the document(s) in following formats (i.e jpeg, png, pdf, gif, jpg).', 'danger');
        }

        return msg;
    }



    getPdfFile(blob, fileName) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = window.URL.createObjectURL(this.dataURLtoBlob(blob));

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(this.dataURLtoBlob(blob), fileName)
            return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        var link = document.createElement('a');
        link.href = newBlob;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(newBlob);
        }, 100)
    }

    dataURLtoBlob(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }
    getArn(param) {
       let url = constants.URLs.BASE_ARAMEX_URL + '/customer-id-search';
        return this.http.post(url, param)
    }
    initializeDocument(param: any) {
        let url = constants.URLS.docUploadEndPoint + '/docInitialize';
        return this.http.post(url, param)
    }

    uploadDocument(param) {
        let url = constants.URLs.docUploadEndPoint + '/docUpload';
        return this.http.post(url, param)
    }

    deleteDocument(param) {
        let url = constants.URLs.docUploadEndPoint + '/deleteDoc';
        return this.http.post(url, param)
    }
    validateEmiratesID(param){
        let url = constants.URLs.BASE_ARAMEX_URL + '/validate-emirates-cn1';
        return this.http.post(url, param)
        
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/services/doc-upload.service.ts